export default {"src":"/_next/static/media/avalanche-icon.7634d3e1.svg","height":30,"width":31};